import {
  GET_LIST_CHITIETCUAHANG,
  GET_LIST_CHITIETCUAHANG_SUCCESS,
  GET_LIST_CHITIETCUAHANG_FAILURE,
} from "actions/ChiTietCuaHang/actionTypes";

const initialState = {
  getListChiTietCuaHangLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListChiTietCuaHang = (state, action) => ({
  ...state,
  getListChiTietCuaHangLoading: true,
});

const getListChiTietCuaHangSuccess = (state, action) => {
  return {
    ...state,
    getListChiTietCuaHangLoading: false,
    objList: action.payload,
  };
};

const getListChiTietCuaHangFailed = (state, action) => ({
  ...state,
  getListChiTietCuaHangLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CHITIETCUAHANG:
      return getListChiTietCuaHang(state, action);
    case GET_LIST_CHITIETCUAHANG_SUCCESS:
      return getListChiTietCuaHangSuccess(state, action);
    case GET_LIST_CHITIETCUAHANG_FAILURE:
      return getListChiTietCuaHangFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
